import { render, staticRenderFns } from "./SenatiFormulariodeEvaluacionSCC.vue?vue&type=template&id=1d8fe529&"
import script from "./SenatiFormulariodeEvaluacionSCC.vue?vue&type=script&lang=js&"
export * from "./SenatiFormulariodeEvaluacionSCC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports